// react
import React from "react"
// app
import AutoComplete from "containers/AutoComplete"
import SelectField, { Style } from "containers/SelectField"
import DatePicker from "components/common/DatePicker"
import TextField from "components/common/TextField"

import * as types from "components/person/types"


export default ({
    type,
    onRatingChange,
    onRatingError,
    onRankChange,
    onHoursChange,
    onValidChange,
    onRateChange
}) => 
    <div>
        <h4>Add
            { type === types.FLIGHT_ATTENDANT ?
                " Type Flown"
                : " Rating" }
        </h4>
        <div className="clearfix">
            <div className="float-left">
                <AutoComplete
                    table="rating"
                    extensible={ true }
                    label={ type === types.FLIGHT_ATTENDANT ?
                        "Type Flown"
                        : "Rating" }
                    mandatory={ true }
                    maxLength={ 50 }
                    onChange={ onRatingChange }
                    onError={ onRatingError }
                />
                { type !== types.FLIGHT_ATTENDANT ?
                    <TextField
                        label={ type === types.ENGINEER ?
                            "Years"
                            : "Hours" }
                        type="number"
                        onChange={ onHoursChange }
                    />
                    : null
                }
            </div>
            <div className="float-right">
                { type === types.FLIGHT_ATTENDANT ||
                    type === types.ENGINEER ?
                    <TextField
                        label="Rank"
                        onChange={ onRankChange }
                    />
                    :
                    <SelectField
                        table="rank"
                        label="Rank"
                        style={ Style.ValueOnly }
                        onChange={ onRankChange }
                    />
                }
                { type !== types.FLIGHT_ATTENDANT ?
                    <DatePicker
                        label="Valid Until"
                        onChange={ onValidChange }
                        value=""
                    />
                    : null
                }
            </div>
        </div>
        { type !== types.ENGINEER ?
            <TextField
                label="Daily Rate"
                hintText="Your daily rate for freelance jobs including per diems"
                onChange={ onRateChange }
            />
            : null
        }
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/person/Ratings/add.js
 **/